<template>
	<div class="wrap">
		<el-row class="tag color-orange" v-if="!showAll">
					<el-col :span="18" class="tag_text">
						<i class="el-icon-circle-close"></i>
						未完成此患者的睡眠评估，无法自动生成睡眠处方，请前去完成评估
					</el-col>
					<el-col :span="6" class="tag_text tag_text_right">
						<!-- <a @click="onEvalShow(sideEvalList)" class="goto">去评估</a> -->
					</el-col>
				</el-row>
		<template v-if="showAll">

		<div v-if="isShow">
			<el-row class="tag color-grey" v-if="tag && !hidden && !isSave">
				<el-col :span="18" class="tag_text">
					<i class="el-icon-info" style="font-size: 15px;"></i>
					已完成对患者的睡眠评估，自动生成睡眠处方，请医生确认后发布
				</el-col>
				<el-col :span="6" class="tag_text tag_text_right">
					<a @click="isHidden" class="know">我知道了</a>
				</el-col>
			</el-row>
		</div>
		<el-form ref="form" :model="form" :rules="rules" label-width="80px">
			<div class="body" id="sleep">
				<div class="item">
					<h2 class="cf">睡眠处方</h2>
				</div>
				<div v-show="tag" class="item">
					<div class="title">
						评估结果
						<el-button class="exportPdf" v-if="!showSaveBtn" :loading="isLoading" @click="exportPdf">导出处方</el-button>

					</div>
					<div class="text">
						<span>存在睡眠呼吸暂停(OSAHS)的风险级别为：</span>
						<span style="color: #EEC211;" v-show="form.result == 1">低风险</span>
						<span style="color: #E9395B;" v-show="form.result == 2">高风险</span>
					</div>
				</div>
				<div class="mTop10">
					<div class="title item">
						处方内容
					</div>
					<div v-show="!isSave">
						<el-form-item label="" prop="content" label-width="0">
							<el-input type="textarea" placeholder="请输入处方内容"  v-model="form.content" rows="10"></el-input>
						</el-form-item>
					</div>
					<div v-show="isSave">
						<div class="desc item">
							{{form.content}}
						</div>
					</div>
				</div>
				<el-row class="dealwith">
					<el-col :span="12"  v-if="!showSaveBtn">
						责任医师：{{form.name}}<br/>
						发布时间：{{form.time}}
					</el-col>
					<el-col :span="12" class="tag_text_right" v-if="prescriptionItem.hospitalSleepVO?.pushTime">
						推送时间：{{prescriptionItem.hospitalSleepVO.pushTime}}
					</el-col>
				</el-row>
			</div>
			
			<div class="body hide" id="sleep_print">
				<div class="item">
					<h2 class="cf">睡眠处方</h2>
				</div>
				<div style="color: #333;font-weight: normal;margin:16px 0;text-align: center;">姓名：{{ medicalRecordDetail.patientName}}&nbsp;&nbsp;&nbsp;&nbsp;科室：{{ medicalRecordDetail.department}}&nbsp;&nbsp;&nbsp;&nbsp;床号：{{medicalRecordDetail.inpatientArea}}-{{ medicalRecordDetail.hospitalBed}}床</div>
				<div v-show="tag" class="item">
					<div class="title">
						评估结果
					</div>
					<div class="text">
						<span>存在睡眠呼吸暂停(OSAHS)的风险级别为：</span>
						<span style="color: #EEC211;" v-show="form.result == 1">低风险</span>
						<span style="color: #E9395B;" v-show="form.result == 2">高风险</span>
					</div>
				</div>
				<div class="mTop10">
					<div class="title item">
						处方内容
					</div>
					<div v-show="isSave">
						<div class="desc item">
							{{form.content}}
						</div>
					</div>
				</div>
				<el-row v-if="!showSaveBtn" class="dealwith">
					<el-col :span="12">
						责任医师：{{form.name}}
					</el-col>
					<el-col :span="12" class="tag_text_right">
						发布时间：{{form.time}}
					</el-col>
				</el-row> 
			</div>
			
			<div v-show="isShow">
				<div class="save" v-if="showSaveBtn">
					<el-button type="primary" :loading="isLoading" @click="save('form')">发 布</el-button>
				</div>
				<div class="save" v-if="!showSaveBtn">
					<el-popconfirm confirmButtonText='删除' title="确定删除处方吗？" @confirm="delPrescription">
						<!--  -->
						<el-button slot="reference" style="float: left;" type="danger" :loading="isLoading" >删除处方</el-button>
					</el-popconfirm>

					<el-button type="primary" :loading="isLoading" @click="update">修改处方</el-button>
					<el-button :loading="isLoading" @click="dialogVisible=true" v-if="patientInfo.wxBindingState == 1">推送处方</el-button>
					<span style="opacity: 0;">{{ this.prescriptionItem.hospitalSleepVO.id }}</span>
				</div>
			</div>
		</el-form>
	</template>

		<SendDialog v-if="dialogVisible" :dialogVisible.sync="dialogVisible" type="5" :prescriptionId="prescriptionItem.hospitalSleepVO.id" />

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import htmlToPdf from '@/service/htmlToPdf'
	import SendDialog from './sendDialog.vue';

	export default {
		components: {
			SendDialog
		},
		props:{
			patientInfo:{
				required: true
			},
			recordId: {
				required: true
			},
			patientId: {
				required: true
			},
			datasources: {
				// required: true
				default: null

			},
			onEvalShow: {
				type: Function,
				default: null
			},
			isShow:{
				type:Boolean,
				default: true
			},
			sideEvalList:{
				// required: true
				default: null

			},
			medicalRecordDetail:{
				// required:true
				default: null

			}
		},
		data() {
			return{
				tag:true,
				hidden:false,
				form:{
					result:0,
					content:"",
					name:"",
					time:"",
				},
				isLoading:false,
				showSaveBtn:true,
				isSave:false,
				prescriptionItem:{},
				rules: {
					content: [{
						required: true,
						message: '请输入处方内容',
						trigger: 'blur'
					}],
				},
				dialogVisible:false,
				showAll:false,

			}
		},
		async created(){
			let query=this.$route.query;
			if(Number(query.datasources)!=1&&Number(query.datasources)!=2){
				let res=await api.checkPreVisibleTypes({
					recordId:this.recordId,
					type:5
				})
				this.showAll=res.data;
			}else{
				this.showAll=true
			}
		},
		methods:{
			async init(prescriptionItem){

				this.prescriptionItem = prescriptionItem;
				if(this.prescriptionItem.hospitalSleepVO.evalResult != null){
					let evalResult = JSON.parse(this.prescriptionItem.hospitalSleepVO.evalResult);
					
					if(evalResult.evalError == ""){
						this.tag = true;
						this.form.result = evalResult.level;
						
						if(this.prescriptionItem.hospitalSleepVO.content == null){
							let html = "";
							for(let i=0;i<evalResult.prescription.length;i++){
								html += evalResult.prescription[i]+"\n";
							}
							this.form.content = html;
						}
					}else{
						this.tag = false;
					}
				}else{
					this.tag = false;
				}
				if(this.prescriptionItem.hospitalSleepVO.content != null){
					this.hidden = true;
					let content = JSON.parse(this.prescriptionItem.hospitalSleepVO.content);
					if(content.result != 0 && content.result != null){
						this.tag = true;
					}
					this.form = content;
					this.showSaveBtn = false;
					this.isSave = true;
				}
			},
			save(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.isLoading = true;
						let user = JSON.parse(localStorage.getItem("user"));
						let myDate = new Date();
						let time = myDate.getFullYear()+"/"+(myDate.getMonth()+1)+"/"+myDate.getDate()+" "+myDate.toLocaleTimeString();
						let data = [];
						data.push({
							"content": JSON.stringify({
								result:this.form.result,
								content:this.form.content,
								name:user.data.name,
								time:time
							}),
							"datasources": this.datasources,
							"patientId": this.patientId,
							"prescriptionType": 5,
							"recordId": this.recordId,
							"state": 1
						});
						let res = await api.addPrescription(data);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}
						this.showSaveBtn = false;
						this.isSave = true;
						
						this.form = {
							result:this.form.result,
							content:this.form.content,
							name:user.data.name,
							time:time
						}
						this.$emit('trigger-event',5);
					}
				});
			},
			update(){
				this.showSaveBtn = true;
				this.isSave = false;
				this.prescriptionItem.hospitalSleepVO.pushTime=null

			},
			exportPdf(){
				htmlToPdf.outPutPdfFn(document.querySelector("#sleep_print"), "睡眠处方");
			},
			isHidden(){
				this.hidden = true;
			},
			async delPrescription(){
				let res=await api.delPrescription({
					id:this.prescriptionItem.hospitalSleepVO.id,
					prescriptionType:5
				})
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.showSaveBtn = true;
				this.isSave = false;
				this.form = {
								result:0,
								content:"",
								name:"",
								time:"",
							}
						this.$emit('trigger-event',5);

			}
		}
	}
</script>

<style lang="less" scoped>
.wrap{
	min-height: 300px;
}
::v-deep .alert{
		margin: 0 auto;
		width: 80%;
	}
.body{
		padding: 20px 120px;
		font-size: 20px;
		color: #409EFF;
	}
	.exportPdf{
		float: right;
		margin-top: -18px;
		background: #fff;
		color: #699ce4;
		border-radius: 20px;
		padding: 6px 12px;
	}
	.title{
		border-bottom: 3px solid #409EFF;
		margin-bottom: 20px;
	}
	
	input{
		width: 99%;
		font-size: 14px;
		height: 40px;
		margin-bottom: 20px;
		color: #333333;
		border: none;
		outline: none;
	}
	
	.el-form .el-textarea {
		width: 100%;
		font-size: 14px;
		border-radius: 5px;
		resize: none;
		outline: none;
		line-height: 30px;
	}
	
	textarea{
		min-height: 150px;
		font-size: 14px;
	}
	
	.save{
		text-align: right;
		padding: 20px 120px;
	}
	
	.dealwith{
		color: #333333;
		font-size: 14px;
		padding-top: 20px;
	}
	
	.saveText{
		background-color: #EFF8FE;
		border-color: #409EFF;
	}
	
	.text{
		font-size: 14px;
		margin: 15px 0;
		color: #333333;
	}
	
	.tag{
		border-radius: 5px;
		height: 35px;
		margin: 0 30px;
		padding: 0 15px;
		font-size: 13px;
	}
	
	.color-grey{
		background-color: #E6E6E6;
		color: #4D4D4D;
	}
	
	.color-orange {
		background-color: #FFECEC;
		color: #FF5D5D;
	}

	
	.desc{
		border-radius: 5px;
		border: 1px solid #409EFF;
		background-color: #EFF8FE;
		margin: 30px 0;
		padding: 20px;
		font-size: 14px;
		color: #333333;
		line-height: 30px;
		white-space: pre-line;
	}
	
	.know{
		color: #4D4D4D;
		cursor: pointer;
	}
	
	.goto{
		color: #FF5D5D;

		cursor: pointer;
	}
	
	.tag_text {
		line-height: 35px;
		font-size: 14px;
	}
	
	.tag_text_right {
		text-align: right;
	}
	
	.tag_text_center {
		text-align: center;
	}
	
	.title {
		border-bottom: 3px solid #409EFF;
		margin-bottom: 20px;
		font-size: 20px;
	}
	
	.cf {
		font-size: 24px;
		text-align: center;
		color: #333333
	}
	
	.mTop10 {
		margin-top: 10px;
	}
	
	.m20 {
		margin: 20px 0;
	}
	
	.table{
		text-align: center;
		font-size: 14px;
		color: #333333;
		width: 100%;
	}
	
	/deep/.el-input__inner{
		width: 60%;
		height: 30px;
	}
	
	#sleep_print{
		.body {
			padding: 20px 120px;
			font-size: 18px;
			color: #409EFF;
		}
		
		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
		}
		
		
		.save {
			text-align: right;
			padding: 20px 120px;
		}
		
		.dealwith {
			color: #000;
			font-size: 16px;
			padding-top: 20px;
		}
		
		.saveText {
			background-color: #EFF8FE;
			border-color: #409EFF;
		}
		
		.text {
			font-size: 24px;
			margin: 15px 0;
			color: #000;
		}
		
		.tag {
			border-radius: 5px;
			height: 35px;
			margin: 0 30px;
			padding: 0 15px;
			font-size: 16px;
		}
		
		.h20{
			height: 20px;
		}
		
		.color-grey {
			background-color: #E6E6E6;
			color: #4D4D4D;
		}
		
		.color-orange {
			background-color: #FEF8DE;
			color: #EEC211;
		}
		
		table {
			border: 1px solid #4D4D4D;
			border-collapse: collapse;
			border-spacing: 0;
		}
		
		table th {
			height: 40px;
			border: 1px solid #4D4D4D;
		}
		
		table td {
			padding: 10px;
			height: 20px;
			border: 1px solid #4D4D4D;
			width: 25%;
		}
		
		.table{
			text-align: center;
			font-size: 17px;
			color: #333333;
			width: 100%;
		}
		
		.topic {
			background-color: #CFEAFC;
		}
		
		.sx {
			width: 5px;
			background-color: #409EFF;
			height: 22px;
			border-radius: 5px;
			float: left;
			margin-right: 10px;
			margin-top: 3px;
		}
		
		.el-form .el-input:not(.el-transfer-panel__filter){
			width: 60%;height: 30px;
		}
		
		.desc {
			border-radius: 5px;
			border: 1px solid #409EFF;
			background-color: #EFF8FE;
			margin: 30px 0;
			padding: 20px 20px 20px 40px;
			font-size: 18px;
			color: #000;
			line-height: 40px;
		}
		
		/deep/.el-form-item__content{
			margin-top: 18px;
		}
		
		/deep/.el-form-item__error {
			margin-left: 40%;
		}
		
		.text_dec{
			text-align: left;
			padding-left: 5px;
			line-height: 40px;
			margin-top: 18px
		}
		
		.know{
			color: #4D4D4D;
			cursor: pointer;
		}
		
		.goto{
			color: #EEC211;
			cursor: pointer;
		}
		
		.tag_text {
			line-height: 35px;
			font-size: 18px;
		}
		
		.tag_text_right {
			text-align: right;
		}
		
		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
			font-size: 26px;
		}
		
		.cf {
			font-size: 30px;
			text-align: center;
			color: #000
		}
		
		.mTop10 {
			margin-top: 10px;
		}
		
		.m20 {
			margin: 40px 0;
		}
		
	}
	
	
	.hide{
		position: absolute;
		z-index: -999;
	}
</style>